// extracted by mini-css-extract-plugin
export default {"fee__wrapper":"FeeItem_fee__wrapper__KZag8"};